export default "__VITE_ASSET__C_OA9nOO__"